module.exports = __webpack_public_path__ + "headerSlideFirst.ec205bf7e1058211afe2.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/assets/coverPicks/headerSlideFirst.jpg
// module id = ../../../../../src/assets/coverPicks/headerSlideFirst.jpg
// module chunks = 0